import { useCurrentVersionStore } from '@/stores/useCurrentVersionStore'
import { useActiveVersionId } from './useActiveVersionId'

/**
 * Returns the effective version ID for UI display.
 * Checks the Zustand store for an explicitly set current version first,
 * then falls back to the active version from the backend.
 */
export function useCurrentVersionId(planId: string | undefined) {
  const storedVersionId = useCurrentVersionStore(state =>
    planId ? state.versionsByPlan[planId] : undefined
  )
  const setCurrentVersion = useCurrentVersionStore(
    state => state.setCurrentVersion
  )
  const clearCurrentVersion = useCurrentVersionStore(
    state => state.clearCurrentVersion
  )

  const {
    data: activeVersionId,
    isLoading,
    isError,
  } = useActiveVersionId(planId)

  const versionId = storedVersionId ?? activeVersionId ?? undefined
  const isViewingNonActiveVersion =
    !!storedVersionId &&
    !!activeVersionId &&
    storedVersionId !== activeVersionId

  return {
    versionId,
    activeVersionId: activeVersionId ?? undefined,
    isViewingNonActiveVersion,
    isLoading,
    isError,
    setCurrentVersion: (versionId: string) => {
      if (planId) setCurrentVersion(planId, versionId)
    },
    clearCurrentVersion: () => {
      if (planId) clearCurrentVersion(planId)
    },
  }
}
